import { render, staticRenderFns } from "./MessagesModal.vue?vue&type=template&id=156f0dfe&scoped=true"
import script from "./MessagesModal.vue?vue&type=script&lang=js"
export * from "./MessagesModal.vue?vue&type=script&lang=js"
import style0 from "./MessagesModal.vue?vue&type=style&index=0&id=156f0dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f0dfe",
  null
  
)

export default component.exports